import {Component} from '@angular/core';
import {FormBuilder, Validators, FormGroup} from "@angular/forms";
import {Router} from "@angular/router";
import {AuthenticationService, AlertService} from "../../services/index";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})


export class LoginComponent {
  loading = false;
  loginForm:FormGroup;

  constructor(private router:Router,
              private alertService:AlertService,
              private authenticationService:AuthenticationService,
              private fb:FormBuilder) {
    this.loginForm = fb.group({
      'password': [null, Validators.compose([Validators.required, Validators.minLength(8), Validators.maxLength(10)])],
      'email': [null, Validators.compose([Validators.required, Validators.email])],
    })
  }

  submitForm(value:any) {
    this.loading = true;
    this.authenticationService.login(value.email, value.password)
      .subscribe(
        data => {
          this.alertService.success('Login successful', true);
          this.router.navigate(['/home']);
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
        });
  }
}



// WEBPACK FOOTER //
// /root/production/sne-pro/src/app/component/login/login.component.ts